import React, { Fragment, useState } from "react";
import ModalFrame from "../../../../toolkit/modalFrame";

import { Button, Row, Col } from "reactstrap";
import { setCustomDonationUrl } from "../../../../utils/fetch";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { ScaleLoader } from "react-spinners";
import "firebase/compat/auth";
import { serviceCaller, ServiceCallerProps } from "../../../composition";

import UrlInput from "../../../../toolkit/urlInput";

interface Props extends ServiceCallerProps {
  isOpen: boolean;
  toggle: () => void;
  charityId: string;
  charityName: string;
  charityCurrentGiveUrl: string;
}

enum DisplayState {
  InsertNewUrl,
  ConfirmUrl,
}

const renderButtons = (
  acceptDisabled: boolean,
  acceptAction: () => void,
  cancelAction: () => void
) => {
  return (
    <div className={s.centered}>
      <Row>
        <Col xs={1}></Col>
        <Col xs={5}>
          <Button onClick={cancelAction} className={s.button}>
            Cancel
          </Button>
        </Col>
        <Col xs={5}>
          <Button
            onClick={acceptAction}
            className={s.button}
            disabled={acceptDisabled}
          >
            Accept
          </Button>
        </Col>
        <Col xs={1}></Col>
      </Row>
    </div>
  );
};

function EditGiveUrlModal(props: Props) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [validUrl, setValidUrl] = useState(false);
  const [displayState, setDisplayState] = useState(DisplayState.InsertNewUrl);

  const toggle = () => {
    setDisplayState(DisplayState.InsertNewUrl);
    props.toggle();
    setLoading(false);
  };

  const setUrlInConfig = () => {
    setLoading(true);
    setCustomDonationUrl(
      props.charityId,
      props.config.adminServiceUrl,
      props.serviceAccessToken,
      url
    ).then(_response => {
      setLoading(false);
      toggle();
    });
  };

  const renderInsertNewUrl = () => {
    return (
      <Fragment>
        <div className={s.marginBot}>
          <UrlInput
            label={"New donation url for " + props.charityName}
            disabled={false}
            onUrlChange={(url, valid) => {
              setUrl(url);
              setValidUrl(valid);
            }}
          />
        </div>
        {renderButtons(
          !validUrl,
          () => setDisplayState(DisplayState.ConfirmUrl),
          toggle
        )}
      </Fragment>
    );
  };

  const renderConfirmUrl = () => {
    return (
      <Fragment>
        <div className={s.marginBot}>
          Are you sure you want to change the donation URL of{" "}
          {props.charityName}?
        </div>
        <div className={s.marginBot}>
          Previous URL:{" "}
          <a href={props.charityCurrentGiveUrl} target="_blank">
            {props.charityCurrentGiveUrl}
          </a>
        </div>
        <div className={s.marginBot}>
          New URL:{" "}
          <a href={url} target="_blank">
            {url}
          </a>
        </div>
        {renderButtons(false, setUrlInConfig, toggle)}
      </Fragment>
    );
  };

  return (
    <ModalFrame
      isOpen={props.isOpen}
      toggle={toggle}
      size="xl"
      title={"Edit Charity's Give Url"}
      subtitle={""}
    >
      <div className={s.centered}>
        <ScaleLoader color={"#1f65b1"} loading={loading} />
      </div>
      {!loading &&
        displayState == DisplayState.InsertNewUrl &&
        renderInsertNewUrl()}
      {!loading &&
        displayState == DisplayState.ConfirmUrl &&
        renderConfirmUrl()}
    </ModalFrame>
  );
}

export default serviceCaller(withStyles(s)(EditGiveUrlModal));
